// Wake up the Render free-tier backend so it doesn't cold-start on the
// user's first authenticated request. Render sleeps after ~15 min of
// inactivity; the first request after that takes 30-50 s. Calling the
// health endpoint as soon as the user lands on a public page (Landing,
// Auth) means the backend is usually warm by the time they submit a
// form.
//
// Fire-and-forget: errors are swallowed since the user's actual request
// will surface any real backend problem.

import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let warmedAt = 0;
const COOL_AFTER_MS = 5 * 60 * 1000; // re-ping if we haven't pinged in 5 min

export const pingBackend = () => {
  const now = Date.now();
  if (now - warmedAt < COOL_AFTER_MS) return;
  warmedAt = now;
  axios.get(`${API}/`, { timeout: 60_000 }).catch(() => {
    warmedAt = 0; // failed, allow retry
  });
};

export default pingBackend;
